import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { SessionService } from './session.service';

export const authGuard: CanActivateFn = async (_route, state): Promise<boolean | UrlTree> => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (await session.ensureSession()) {
    if (session.needsRequiredProfileCompletion() && !state.url.startsWith('/account')) {
      return router.createUrlTree(['/account'], { queryParams: { complete: session.currentUser()?.loginProvider === 'x' || session.currentUser()?.avatarImportProvider === 'x' ? 'x' : 'orcid' } });
    }
    return true;
  }

  return router.createUrlTree(['/login'], { queryParams: { redirectTo: state.url } });
};

export const adminGuard: CanActivateFn = async (_route, state): Promise<boolean | UrlTree> => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (!await session.ensureSession()) return router.createUrlTree(['/login'], { queryParams: { redirectTo: state.url } });
  if (await session.ensureAdmin()) return true;

  return router.createUrlTree(['/403']);
};

export const moderatorGuard: CanActivateFn = async (_route, state): Promise<boolean | UrlTree> => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (!await session.ensureSession()) return router.createUrlTree(['/login'], { queryParams: { redirectTo: state.url } });
  if (await session.ensureModerator()) return true;

  return router.createUrlTree(['/403']);
};

export const guestGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const session = inject(SessionService);
  const router = inject(Router);

  return await session.ensureSession() ? router.createUrlTree(['/dashboard']) : true;
};